import { PRO_NUMBER_VALIDATION_MESSAGES } from "./ValidationMessages";

const addCheckDigitToProNumber = (proId) => {
  if (isNaN(Number(proId))) {
    return proId;
  }
  if ([10, 11, 12].includes(proId.length) && proId.startsWith("700")) {
    // #19319 Append 00 in the end if the pro number scanned starts with 700
    // and has only 10 digits
    if (proId.length === 10) {
      return "00";
    }
    //US: 15716 : OVLD pros are the partner pros that will be delivered by someone else instead of Saia.
    //if the pro is 11 or 12 digits and starts with 700 then it is OVLD pro. For OVLD pros check digit should be 0.
    return 0;
  }
  if (proId.length < 11) {
    proId = proId.padStart(11, "0");
  }
  const actualProId = Number(proId.substr(0, 10));
  const getCalcDigit = Math.floor(actualProId / 7);
  return actualProId - getCalcDigit * 7;
};

export const getProNumberSaia =
  (enableCheckDigit) =>
  ({ proNumber, isProPreAssigned }) => {
    if (enableCheckDigit && isProPreAssigned) {
      return addCheckDigit(proNumber);
    } else if (proNumber === "0") {
      return "";
    }
    return proNumber ?? "";
  };

export const addCheckDigit = (proNumber) => {
  if (
    proNumber.length === 11 ||
    (proNumber.startsWith("700") && proNumber.length === 10)
  ) {
    return proNumber + addCheckDigitToProNumber(proNumber).toString();
  }
  return proNumber;
};

export const validateProNumberSaia = (enableCheckDigit) => ({
  completedProList,
  proNumber,
  shipmentId,
  proNumberLength,
}) => {
  const isMatchWithCompletedPro = completedProList.find(
    (pro) => Number(pro.proNumber) === Number(proNumber)
  );
  if (!proNumber) {
    return PRO_NUMBER_VALIDATION_MESSAGES(proNumberLength).required;
  } else if (isMatchWithCompletedPro) {
    const completedProData = completedProList.find(
      (pro) => Number(pro.proNumber) === Number(proNumber)
    );
    if (completedProData?.shipmentId !== shipmentId) {
      return PRO_NUMBER_VALIDATION_MESSAGES(proNumberLength).duplicateNumber;
    }
  } else if (proNumber.startsWith("700") && proNumber.length < 11) {
    return null;
  } else if (proNumber.trim().length <= 11) {
    const hasLeading0s = proNumber.trim().startsWith("0");
    if (proNumber.trim().length < 11 || hasLeading0s) {
      // Remove all 0s from the beginning of the pro number (if any)
      const zeroRemovedNumber = proNumber.trim().replace(/^0+/, "");
      // If the resulting number is 8 digits or less, then show error
      if (zeroRemovedNumber.length < 9) {
        return PRO_NUMBER_VALIDATION_MESSAGES(proNumberLength).invalidProNumber;
      }
    } else {
      return PRO_NUMBER_VALIDATION_MESSAGES(proNumberLength).proNumberMin;
    }
  } else if (proNumber.length === proNumberLength) {
    // Remove all 0s from the beginning of the pro number (if any)
    const zeroRemovedNumber = proNumber.trim().replace(/^0+/, "");
    // If the resulting number is 9 digits or less, then show error
    if (zeroRemovedNumber.length < 10) {
      return PRO_NUMBER_VALIDATION_MESSAGES(proNumberLength).invalidProNumber;
    }
    if (enableCheckDigit) {
      const enteredCheckDigit = proNumber.slice(-1);
      const calculatedCheckDigit = addCheckDigitToProNumber(
        proNumber.slice(0, 11)
      );
      if (Number(enteredCheckDigit) !== Number(calculatedCheckDigit)) {
        return PRO_NUMBER_VALIDATION_MESSAGES(proNumberLength).invalidCheckDigit;
      }
    }
  } else if (proNumber.trim().length > proNumberLength) {
    return PRO_NUMBER_VALIDATION_MESSAGES(proNumberLength).proNumberMax;
  }
  return null;
};
